











































import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'

@Component({
  components: {
    BuilderDeviceHighlight,
  },
})
export default class BuilderDeviceProfileCoverStub extends Vue {
  @Prop({ default: true, type: Boolean }) blur!: boolean

  @Prop({ default: true, type: Boolean }) highlight!: boolean

  @Prop({ default: null }) cover!: null | { id: number; file: null | string | File }[]

  get isWide(): boolean {
    return !!this.cover && this.cover.length === 1
  }

  get file(): string | null {
    return this.files[0].file
  }

  get files(): { id: number; file: null | string }[] {
    if (!this.cover) {
      return Array.from(new Array(3)).map((_, i) => ({
        id: -i - 1,
        file: null,
      }))
    }

    return Array.from(new Array(3)).map((_, i) => {
      const item = this.cover && this.cover[i]

      if (!item) {
        return { id: -i - 1, file: null }
      }

      return {
        id: item.id,
        file: item.file instanceof File ? URL.createObjectURL(item.file) : item.file,
      }
    })
  }
}
